<template>
  <div>
    <div v-if="records.length > 0" class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th
                    v-for="column of columns"
                    :key="column"
                    class="px-3 py-1 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                  >
                    {{ column }}
                  </th>
                  <th class="px-3 py-1"></th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="(record, index) of records"
                  :key="record.id"
                  :class="index > rows ? 'hidden' : ''"
                  :data-id="index"
                >
                  <td
                    v-for="column of columns"
                    :key="column"
                    class="px-3 py-2 whitespace-no-wrap text-sm leading-5 text-gray-900"
                  >
                    {{ record[column] }}
                  </td>
                  <td class="px-3 py-2 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="records.length > rows"
            class="mt-2 cursor-pointer text-indigo-600 hover:text-indigo-900 text-center text-sm"
            @click="rows = rows + 4"
          >
            View more
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <LoadingList />
    </div>
  </div>
</template>

<script>
import LoadingList from './LoadingList.vue';

export default {
  props: ['columns', 'records'],
  components: {
    LoadingList,
  },
  data() {
    return {
      rows: 4,
    };
  },
};
</script>
